export const animalNames = [
  "ocelot",
  "giraffe",
  "viper",
  "macaw",
  "bear",
  "ferret",
  "kookaburra",
  "baboon",
  "mandrill",
  "vulture",
  "buzzard",
  "albatross",
  "lemur",
  "otter",
  "raccoon",
  "quail",
  "emu",
  "barracuda",
  "owl",
  "alpaca",
  "eel",
  "cheetah",
  "catfish",
  "eagle",
  "crab",
  "bat",
  "walrus",
  "beetle",
  "fox",
  "seahorse",
  "kangaroo",
  "chameleon",
  "hamster",
  "manatee",
  "sea lion",
  "squid",
  "lobster",
  "orca",
  "cow",
  "wombat",
  "penguin",
  "shark",
  "salamander",
  "dragonfly"
];
